/* @jsxImportSource @emotion/react */

import React from 'react'
import { css } from '@emotion/react'
import { FormattedMessage, useIntl } from 'react-intl'

import { websiteSectionSmallBreakpoint } from '@slite/components'

import { NAVBAR_HEIGHT } from '../../components/Navbar/NavbarSection'
import { Section } from '../../components/Section'
import { SlitePage } from '../../components/SlitePage'
import { WebsiteText } from '../../components/WebsiteText'
import { useRoutes } from '../../routes'
import { NewsletterForm } from './NewsletterForm'

/* Fills the viewport below the navbar so the footer only shows on scroll, and
   grows past it when the content is taller. */
const sectionCss = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - ${NAVBAR_HEIGHT}px);
  min-height: calc(100svh - ${NAVBAR_HEIGHT}px);

  @media (max-width: ${websiteSectionSmallBreakpoint}px) {
    /* Doubled selector: outranks Section's own responsive padding. */
    && {
      padding-bottom: 80px;
    }
  }
`

const columnCss = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 480px;
  margin: 0 auto;
`

export default function NewsletterPage() {
  const intl = useIntl()
  const routes = useRoutes()
  const pageTitle = intl.formatMessage({
    id: 'website.newsletter.helmet.title',
    defaultMessage: 'Stay in the loop | Slite',
  })
  const pageDescription = intl.formatMessage({
    id: 'website.newsletter.helmet.description',
    defaultMessage:
      'Subscribe to the Slite newsletter: product updates, what our team is learning, and new resources, straight to your inbox.',
  })

  return (
    <SlitePage
      title={pageTitle}
      description={pageDescription}
      ogTitle={pageTitle}
      ogDescription={pageDescription}
      canonicalUrl={routes.newsletter()}
      background="moon-dust-lighter"
    >
      <Section
        css={sectionCss}
        containerVerticalPadding={64}
        background="moon-dust-lighter"
      >
        <div css={columnCss}>
          <div className="flexbox flexbox-column flexbox-gap-12 text-align-center">
            <WebsiteText variant="heroTitle">
              <FormattedMessage
                id="website.newsletter.title"
                defaultMessage="Stay in the loop"
              />
            </WebsiteText>
            <WebsiteText variant="body" className="shade-20">
              <FormattedMessage
                id="website.newsletter.description"
                defaultMessage="A short email from the Slite team: product updates, what we're learning about knowledge bases and AI, and new resources worth your time. No spam, unsubscribe anytime."
              />
            </WebsiteText>
          </div>
          <NewsletterForm />
        </div>
      </Section>
    </SlitePage>
  )
}
